/**
 * PURPOSE:
 * Cliente público HAYLLIS para el Módulo de Visualización Arbitral de vóley.
 *
 * ROUTE:
 * src/pages/VolleyballViewer/services/volleyballViewerPublicService.js
 */

import axios from "axios";
import API_BASE_URL from "../../../config/config.js";

export const VOLLEYBALL_VIEWER_SOCKET_URL = `${String(API_BASE_URL).replace(
  /\/$/,
  ""
)}/volleyball-viewer`;

const client = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export async function getViewerPublicStatus(matchId) {
  const response = await client.get(
    `/volleyball-viewer/public/by-match/${matchId}/status`
  );
  return response.data;
}

export async function authViewerPublic(matchId, payload) {
  const response = await client.post(
    `/volleyball-viewer/public/by-match/${matchId}/auth`,
    payload
  );
  return response.data;
}

export async function getViewerPublicSnapshot(matchId, session) {
  const response = await client.get(
    `/volleyball-viewer/public/by-match/${matchId}/snapshot`,
    {
      headers: {
        "x-viewer-session-id": session?.sessionId || "",
        "x-viewer-session-token": session?.sessionToken || "",
        "x-viewer-device-id": session?.deviceId || "",
      },
    }
  );
  return response.data?.payload || response.data;
}
